export default "__VITE_ASSET__OKTnKm8W__"